import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const downloadRpmCoverPage = async (patientId, payload) => {
  const url = interpolate(endpoints.rpm.fetchCoverPage, { patientId });
  const data = await api.post(url, payload, {
    responseType: "blob",
  });
  return data;
};

export const fetchRpmPatientBilling = async (patientId, payload) => {
  const url = interpolate(endpoints.rpm.fetchRpmPatientBilling, { patientId });
  const data = await api.post(url, payload);
  return data;
};
